// removed by extract-text-webpack-plugin
module.exports = {"container":"_1DN7jMUdMdMMkP5jgkj65s_0","wrapper":"_3CS5uEb86cBHJWLhAAuooX_0","card":"_1XRjfP_SRtIo-mYgoMC1rm_0","title":"_3LPjGm3gYWPUzhnCf2vwgo_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e0df944","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = bnsq
// module chunks = 1